import Vue from 'vue';

export default function () {
  return {
    buy(client, msisdn, amount) {
      return Vue.axios.get('/vtae/buy', {
        params: {
          client,
          msisdn,
          amount
        }
      });
    },
    getProfile(msisdn) {
      return Vue.axios.get(`/profile/${msisdn}`);
    },
    sendPin(msisdn) {
      return Vue.axios.get(`/pin/send/${msisdn}`);
    },
    confirmPin(msisdn, pin) {
      return Vue.axios.get(`/pin/confirm/${msisdn}`, {
        params: {
          pin
        }
      });
    },
    purchases(msisdn) {
      return Vue.axios.get(`/profile/${msisdn}/purchases`);
    },
    test() {
      return Vue.axios.get('/vtae/getorder?msisdn=1231231231&amount=100');
    },
    factura(NoTicket, Fecha, Total) {
      const url = 'http://srvfacturasenlinea.com.mx/api_servFactura_test2?';
      return `${url}NoTicket=${NoTicket}&Fecha=${Fecha}&Total=${Total}`;
    }
  };
}



// WEBPACK FOOTER //
// ./src/api/claroApi.js